
      var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUpdateContactAndAccountDetailsIconError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 97.006,
  height: 97.005,
  viewBox: "0 0 97.006 97.005"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".update_contact_and_account_details_icon_error_4731699cfa748a61__cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;fill-rule:evenodd}"))), /*#__PURE__*/React.createElement("g", {
  id: "update_contact_and_account_details_icon_error_4731699cfa748a61__icons-error_1_",
  "data-name": "icons-error (1)",
  transform: "translate(2.5 2.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "update_contact_and_account_details_icon_error_4731699cfa748a61__Group_23",
  "data-name": "Group 23"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "update_contact_and_account_details_icon_error_4731699cfa748a61__Path_10",
  "data-name": "Path 10",
  className: "update_contact_and_account_details_icon_error_4731699cfa748a61__cls-1",
  d: "M60.878 35.222v-7.5l16.439 14.45-16.439 14.574v-7.5h-6.31s-7.985-.5-8.971 6.674a9.678 9.678 0 0 0 0 1.5v11.574a5.455 5.455 0 0 1-3.35 5.259 5.322 5.322 0 0 1-6.015-1.409l-.247-.275a5.493 5.493 0 0 1-1.33-3.575V47.721s-.222-6.774 4.732-9.874a9.273 9.273 0 0 1 3.351-1.325 14.6 14.6 0 0 1 2.687-.25",
  transform: "translate(-5.453 -5.345)"
})), /*#__PURE__*/React.createElement("circle", {
  id: "update_contact_and_account_details_icon_error_4731699cfa748a61__Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 2.133,
  cy: 2.133,
  r: 2.133,
  transform: "translate(47.332 28.778)",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
}), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  id: "update_contact_and_account_details_icon_error_4731699cfa748a61__Path_11",
  "data-name": "Path 11",
  className: "update_contact_and_account_details_icon_error_4731699cfa748a61__cls-1",
  d: "m12.82 40.219 27.995-28a18.007 18.007 0 0 1 25.466 0l28 28a18.007 18.007 0 0 1 0 25.466l-28 27.995a18.007 18.007 0 0 1-25.466 0L12.82 65.685a18.007 18.007 0 0 1 0-25.466z",
  transform: "translate(-7.546 -6.949)"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"97.006\" height=\"97.005\" viewBox=\"0 0 97.006 97.005\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;fill-rule:evenodd}\r\n        </style>\r\n    </defs>\r\n    <g id=\"icons-error_1_\" data-name=\"icons-error (1)\" transform=\"translate(2.5 2.5)\">\r\n        <g id=\"Group_23\" data-name=\"Group 23\">\r\n            <path id=\"Path_10\" data-name=\"Path 10\" class=\"cls-1\" d=\"M60.878 35.222v-7.5l16.439 14.45-16.439 14.574v-7.5h-6.31s-7.985-.5-8.971 6.674a9.678 9.678 0 0 0 0 1.5v11.574a5.455 5.455 0 0 1-3.35 5.259 5.322 5.322 0 0 1-6.015-1.409l-.247-.275a5.493 5.493 0 0 1-1.33-3.575V47.721s-.222-6.774 4.732-9.874a9.273 9.273 0 0 1 3.351-1.325 14.6 14.6 0 0 1 2.687-.25\" transform=\"translate(-5.453 -5.345)\"/>\r\n            <circle id=\"Ellipse_4\" data-name=\"Ellipse 4\" cx=\"2.133\" cy=\"2.133\" r=\"2.133\" transform=\"translate(47.332 28.778)\" style=\"fill:var(--theme-primary, #810ea9)\"/>\r\n            <path id=\"Path_11\" data-name=\"Path 11\" class=\"cls-1\" d=\"m12.82 40.219 27.995-28a18.007 18.007 0 0 1 25.466 0l28 28a18.007 18.007 0 0 1 0 25.466l-28 27.995a18.007 18.007 0 0 1-25.466 0L12.82 65.685a18.007 18.007 0 0 1 0-25.466z\" transform=\"translate(-7.546 -6.949)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/update_contact_and_account_details_icon_error.4731699cfa748a612982529bae994108.svg"),
        {
          React: SvgUpdateContactAndAccountDetailsIconError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      